import { useIntl } from "react-intl";

import { useListingData } from "~/context/ListingPageDataContext";

import { getRoomTypeWithDurationMessage } from "../../utils/fsv.utils";
import { FsvCard } from "../FsvCard";

export const FsvSpaceCard = () => {
  const intl = useIntl();
  const { data: listingData } = useListingData();

  const fullServiceDetails = listingData.fullService!;
  const capacityMin = listingData.attendeesMin;
  const hasValidCapacityMin = capacityMin != null && capacityMin > 0;
  const minimumDuration = parseFloat(listingData.listingMinimumDuration ?? "0");

  return (
    <FsvCard
      testId="fsv-space-card"
      title={getRoomTypeWithDurationMessage(
        fullServiceDetails.room_type,
        minimumDuration,
        intl,
      )}
      description={
        hasValidCapacityMin
          ? intl.formatMessage(
              {
                defaultMessage: "Great for {capacityRange} people",
              },
              {
                capacityRange: `${capacityMin}–${listingData.listingCapacity}`,
              },
            )
          : intl.formatMessage(
              {
                defaultMessage: "Up to {capacity} people",
              },
              {
                capacity: listingData.listingCapacity,
              },
            )
      }
    />
  );
};
